import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { ArrowRightIcon, CalendarIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { bids } from '../../data/bids';
export function LatestBids() {
  const latestBids = bids.filter(b => b.status !== 'closed').slice(0, 4);
  return <section className="py-20 bg-white" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4" data-id="element-112">
        <SectionHeading title="Current Bids & Tenders" subtitle="Explore procurement opportunities and submit your proposals" data-id="element-113" />

        <div className="grid md:grid-cols-2 gap-6 mt-12" data-id="element-114">
          {latestBids.map((bid, index) => <motion.div key={bid.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-115">
              <Card hover data-id="element-116">
                <div className="flex items-start justify-between mb-3" data-id="element-117">
                  <span className="text-sm font-mono text-gray-500" data-id="element-118">
                    {bid.reference}
                  </span>
                  <StatusPill status={bid.status} data-id="element-119">
                    {bid.status === 'closing-soon' ? 'CLOSING SOON' : 'OPEN'}
                  </StatusPill>
                </div>
                <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-120">
                  {bid.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-121">{bid.description}</p>
                <div className="flex items-center gap-4 text-sm text-gray-600 mb-3" data-id="element-122">
                  <div className="flex items-center gap-1" data-id="element-123">
                    <CalendarIcon size={16} data-id="element-124" />
                    <span data-id="element-125">
                      Published:{' '}
                      {new Date(bid.publicationDate).toLocaleDateString('en-GB')}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-sm font-medium text-au-red mb-4" data-id="element-126">
                  <ClockIcon size={16} data-id="element-127" />
                  <span data-id="element-128">
                    Deadline:{' '}
                    {new Date(bid.deadline).toLocaleDateString('en-GB')}
                  </span>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-129">
                  <span className="text-sm text-gray-600" data-id="element-130">{bid.category}</span>
                  {bid.estimatedValue && <span className="text-sm font-bold text-charcoal" data-id="element-131">
                      {bid.estimatedValue}
                    </span>}
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-132">
          <Link to="/bids" data-id="element-133">
            <Button variant="primary" className="flex items-center gap-2 mx-auto" data-id="element-134">
              View All Bids
              <ArrowRightIcon size={20} data-id="element-135" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}